import { CSSProperties } from 'react';
import { CONSTANTS } from '../../UIConstants';

export const Home: CSSProperties = {
    flexGrow: CONSTANTS.FLEX_GROW.ONE, 
    overflowY: 'auto', 
    paddingLeft: 32, 
    paddingRight: 32, 
    paddingTop: 20, 
};

export const PanelContainer: CSSProperties = {
    display: CONSTANTS.DISPLAY.FLEX,
    flexGrow: CONSTANTS.FLEX_GROW.ONE,
    justifyContent: CONSTANTS.FLEX_JUSTIFY.CENTER, 
    flexWrap: CONSTANTS.FLEX_WRAP.WRAP,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/styles/Pages/Home.ts